import { useEffect } from 'react';

/**
 *
 * @param {{children:import("react").ReactNode, isOpen:boolean}} param0
 * @returns
 */
export default function Modal({ children, isOpen }) {
  // Block page scrolling when modal is open

  useEffect(() => {
    const element = document.getElementById('main-content-layout-parent');
    if (!!!isOpen || !!!element) return;

    element.style.overflow = 'hidden';
    element.style.paddingRight = '14px';

    return () => {
      element.style.overflow = '';
      element.style.paddingRight = '';
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex flex-col items-center px-5 overflow-y-auto bg-black md:grid md:place-items-center bg-opacity-30 backdrop-filter backdrop-blur-sm">
          {children}
        </div>
      )}
    </>
  );
}
